import(/* webpackMode: "eager" */ "C:\\my project\\work\\gitlab910\\website\\home\\scrm-saas-home\\src\\app\\page.tsx");
